import { ESuccessModalType } from '../../types/successModalType';
import { selectIsLkPaymentInitSource } from '../payment';
import { EBuyPackageStatus, TAppState } from '../../types';
import { selectBuyPackageModalStatus, selectIsSubscription } from '../buyPackageModal';

export const selectSuccessModalType = (state: TAppState): ESuccessModalType => {
  const isSubscription = selectIsSubscription(state);
  const status = selectBuyPackageModalStatus(state);
  const isLkPaymentInitSource = selectIsLkPaymentInitSource(state);

  const isPaymentHolded = status === EBuyPackageStatus.OkWithDeposit;

  if (isLkPaymentInitSource && !isPaymentHolded) {
    return ESuccessModalType.PackageWithRedirect;
  }

  if (isSubscription) {
    return isPaymentHolded ? ESuccessModalType.SubscriptionWithHold : ESuccessModalType.Subscription;
  }

  if (isPaymentHolded) {
    return ESuccessModalType.PackageWithHold;
  }

  return ESuccessModalType.Package;
};
